import { MetricConfig } from "./tvd-types";

export const PestTvdNavbarMetricsConfig: MetricConfig[] = [
    {
        metricName: "Operational Performance",
        metricSubHeader: "",
        metrics: [
            {
                id:'nochargeadditionalcomultiplier',
                title: "No Charge Additional Services",
                isHidden: false,
                isIncludePayload:true,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                    {
                        id:'valueofservice',
                        title: "Value of Service",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true,
                    },
                    {
                        id:'rodentservicemultiplier',
                        title: "Rodent Service Multiplier",
                        isHidden: false,
                        isCurrencyVisible:false,
                        isDefaultValueVisible:true,
                    },                    
                ]
            },
            {
                id:'generalcontractorcostavoidance',
                title: "General Contractor (GC) Cost Avoidance",
                isHidden: false,
                isIncludePayload:false,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                    {
                        id:'generalcontractorcostavoidance',
                        title: "Cost of a GC",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true,
                    },
                ]
            },
            {
                id:'setupservicescomultiplier',
                title: "Set-up Services",
                isHidden: false,
                isIncludePayload:true,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                {
                        id:'valueofservice',
                        title: "Value of Service",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true,
                    },
                    {
                        id:'setupservicescomultiplier',
                        title: "C/O Multiplier",
                        isHidden: false,
                        isDefaultValueVisible:true,
                        isCurrencyVisible:false,
                    }
                ]
            },
            {
                id:'preventionfindings',
                title: "Pest Prevention Findings",
                isHidden: false,
                isIncludePayload:false,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                    {
                        id:'preventionfindings',
                        title: "Value of a Finding",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true,
                    },
                ]
            },
            {
                id:'roomprice',
                title: "Room Nights Saved",
                isHidden: false,
                isIncludePayload:false,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                {
                        id:'roomprice',
                        title: "Room Price",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true
                    },
                    {
                        id:'numberofroomnights',
                        title: "# of Days",
                        isHidden: false,
                        isDefaultValueVisible:true,
                        staticUOM:'Days',
                        isDecimal:false,
                    }
                ]
            },
            {
                id:'furniturepreservationassets',
                title: "Furniture Preservation (Assets)",
                isHidden: false,
                isIncludePayload:false,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                    {
                        id:'furniturepreservationassets',
                        title: "Assets",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true,
                    },
                ]
            }
        ]
    },
    {
        metricName: "Environmental Impact",
        metricSubHeader: "",
        metrics: [
            {
                id:'furniturepreservationenergy',
                title: "Furniture Preservation (Energy)",
                isHidden: false,
                isIncludePayload:true,
                isTwoFactorsApplicable:true,
                twoFactorMetrics:[
                    {
                        id:'furniturepreservationenergy',
                        title: "Energy",
                        isHidden: false,
                        isCurrencyVisible:true,
                        isDefaultValueVisible:true,
                    },
                ]
            },
        ]
    }
];
